import { Pipe, PipeTransform } from '@angular/core';

import { ContractStatus } from '@gi/enums/contract-status.enum';
import { Contract } from '@gi/models/contract';

@Pipe({
  name: 'canCreateProspectCompany',
  standalone: true
})
export class CanCreateProspectCompanyPipe implements PipeTransform {
  transform(prospectContracts: Contract[]): boolean {
    return (
      !!prospectContracts?.length &&
      !prospectContracts?.some((contract: Contract) => contract.status === ContractStatus.sent)
    );
  }
}
